import React from 'react';
// استيراد Navigate لاستخدامها في التوجيه التلقائي للمسارات المجهولة
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import LessonBuilder from './pages/LessonBuilder';
import WelcomePage from './pages/WelcomePage';
import LoginPage from './pages/LoginPage';
import WorkshopWorkspace from './pages/WorkshopWorkspace';
import ActivityStudio from './pages/ActivityStudio';
import ActivityViewer from './pages/ActivityViewer';
import EvaluationPage from './pages/EvaluationPage';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <LanguageProvider> 
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/login" element={<LoginPage />} />
            
            {/* مسارات الإدارة المركزية (صلاحيات كاملة) */}
            <Route path="/admin" element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            
            {/* مسارات الأطر (صلاحيات جزئية) */}
            <Route path="/workshop" element={
              <ProtectedRoute allowedRoles={['educator']}>
                <WorkshopWorkspace />
              </ProtectedRoute>
            } />
            <Route path="/builder" element={
              <ProtectedRoute allowedRoles={['educator']}>
                <LessonBuilder />
              </ProtectedRoute>
            } />
            <Route path="/studio" element={
              <ProtectedRoute allowedRoles={['educator']}>
                <ActivityStudio />
              </ProtectedRoute>
            } />
            <Route path="/viewer" element={
              <ProtectedRoute allowedRoles={['educator']}>
                <ActivityViewer />
              </ProtectedRoute>
            } />
            <Route path="/evaluation" element={
              <ProtectedRoute allowedRoles={['educator']}>
                <EvaluationPage />
              </ProtectedRoute>
            } />

            {/* شبكة الأمان المعمارية (Fallback Route): توجيه أي مسار خاطئ للرئيسية */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;